module.exports = __webpack_public_path__ + "static/media/file-music.b5c48aac.svg";